module.exports = __webpack_public_path__ + "static/media/main-logo-4-2.e9d2a8ed.png";